import { assertNever } from 'owa-assert';
import loc, { format } from 'owa-localize';
import { InsertLinksStatus } from '../types/InsertLinksStatus';
import {
    SaveCouldNotLoadMultipleLinks,
    SaveCouldNotLoadOneLink,
    SaveFinishLoadingMultipleLinks,
    SaveFinishLoadingOneLink,
    SaveLoadingMultipleLinks,
    SaveLoadingOneLink,
} from './insertLinksBlockDialog.locstring.json';

export function getBlockDialogOnSaveLabelString(
    status: InsertLinksStatus,
    fileNames: string
): string {
    switch (status) {
        case InsertLinksStatus.succeededToAddOneLink:
            return loc(SaveFinishLoadingOneLink);
        case InsertLinksStatus.succeededToAddMultipleLinks:
            return loc(SaveFinishLoadingMultipleLinks);
        case InsertLinksStatus.failedToInsertOneLink:
            return format(loc(SaveCouldNotLoadOneLink), fileNames);
        case InsertLinksStatus.failedToInsertMultipleLinks:
            return format(loc(SaveCouldNotLoadMultipleLinks), fileNames);
        case InsertLinksStatus.loadingOneLink:
            return loc(SaveLoadingOneLink);
        case InsertLinksStatus.loadingMultipleLinks:
            return loc(SaveLoadingMultipleLinks);
        default:
            return assertNever(status);
    }
}
